import React from 'react';
import { Carousel } from 'react-bootstrap';
import '../styles/Visit.css';
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';

const texts = {
  section: {
    en: 'Visit',
    fr: 'Visites',
  },
  block1: {
    title: {
      en: ['Visits and', 'Accommodations'],
      fr: ['Visites et', 'Hebergement'],
    },
    p1: {
      en: 'Château La Croix de Millorit is open for visits and provides accommodation at a historic manor with vast history of wine making traditions.',
      fr: 'Le Château La Croix de Millorit est ouvert aux visites et offre des hébergements dans un manoir imprégné de siècles de tradition viticole.',
    },
    p2: {
      en: 'Set in nearly 20 hectares of garden and vineyard, the château’s traditional exterior meld with contemporary design of recently renovated bedrooms.',
      fr: 'Situé dans près de 20 hectares de jardin et de vignes, l’extérieur traditionnel du château se mêle au design contemporain des chambres récemment rénovées.',
    },
    p3: {
      en: 'You can hire the whole chateau with its six grand bedrooms or a gîte that can accommodate a smaller party between 2–8 people.  You can always visit our tasting room for a degustation of wine as well as small bite.',
      fr: 'Au salon vous pourrez vous relaxer, lire, prendre une tasse de thé ou déguster un verre de vin du vignoble.',
    },
    p4: {
      en: 'Most bedrooms have en-suite bathrooms or shower room with all modern features.',
      fr: '8 grandes chambres avec ensuite',
    },
    bookButton: {
      en: 'book',
      fr: 'réserver',
    },
    allrooms: {
      en: "all-rooms",
      fr: "toutes-les-proprietes"
  }
  }
}

const animate =(inView, animationType, delay, speed)=>{
  const animation = `animate__${animationType}`;
  const animateSpeed = speed ? `animate__${speed}` : '';
  return `animate__animated ${inView ? animation : ''} animate__delay-${delay}s ${animateSpeed}`;
}

const setSection =(section, props, inView)=>{
  if(inView && props.nav !== section){
    if(props.nav === "gallery"){
      setTimeout(()=>{
        props.setNav(section);
      }, 500);
    } else {
      props.setNav(section);
    }
    
  }
}

const Visit =(props)=> {
    const section = 'visit';
    const lang = props.lang;
    const { ref, inView } = useInView({threshold: 0.9});
    useEffect(() => {
      setSection(section, props, inView);
    });
    return (
    <section ref={ref} id="visit" className="visit section">
      <div className="container">
        <div className="section-title">
          <h2 className={animate(inView, 'bounceInDown', 0.2)}>{texts.section[lang]}</h2>
          <h3 className={animate(inView, 'flipInX', 1)}>{texts.block1.title[lang][0]} <span>{texts.block1.title[lang][1]}</span></h3>
          <p className={animate(inView, 'fadeIn', 1, 'slow')}>{texts.block1.p1[lang]}</p>
        </div>
      </div>

      <Carousel>
          <Carousel.Item interval={10000}>
          
            <img
              className="d-block w-100 slide"
              src="../accommodation-2.jpg"
              alt="La Croix De Millorit"
            />
           
            <Carousel.Caption>
              <span><a href={`https://www.bookings.lacroixdemillorit.com/${lang}/${texts.block1.allrooms[lang]}`} className="btn btn-book">{texts.block1.bookButton[lang].toUpperCase()}</a></span>
              <h4>{texts.block1.p2[lang]}</h4>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item interval={10000}>
            <img
              className="d-block w-100 slide"
              src="../accommodation-1.jpg"
              alt="La Croix De Millorit"
            />
            <Carousel.Caption>
              <span><a href={`https://www.bookings.lacroixdemillorit.com/${lang}/${texts.block1.allrooms[lang]}`} className="btn btn-book">{texts.block1.bookButton[lang].toUpperCase()}</a></span>
              <h4>{texts.block1.p3[lang]}</h4>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item interval={10000}>
            <img
              className="d-block w-100 slide"
              src="../accommodation-3.jpg"
              alt="La Croix De Millorit"
            />
            <Carousel.Caption>
              <span><a href={`https://www.bookings.lacroixdemillorit.com/${lang}/${texts.block1.allrooms[lang]}`} className="btn btn-book">{texts.block1.bookButton[lang].toUpperCase()}</a></span>
              <h4>{texts.block1.p4[lang]}</h4>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
    </section>
  );
}

export default Visit